import { css } from '@/styled-system/css';

export const layoutImageContainerStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  position: 'relative',
  flex: 1,
  minHeight: '257px',
  border: '1px solid {colors.border.subtle}',
  borderRadius: '100',
  padding: '100',
});

export const loadingImageStyles = css.raw({
  borderRadius: '100',
  position: 'absolute',
  width: '100% !important',
  height: '100% !important',
});
